import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message, Checkbox, Spin, App } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const STORAGE_KEYS = {
  REMEMBER_ME: 'remember_me',
  SAVED_USERNAME: 'saved_username',
  SAVED_PASSWORD: 'saved_password'
};

// 登录表单组件
const LoginForm = () => {
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login, user } = useAuth();
  const { message: messageApi } = App.useApp();
  const [form] = Form.useForm();

  // 如果已经登录，直接跳转到首页或之前的页面
  useEffect(() => {
    if (!loading && user) {
      const from = location.state?.from?.pathname || '/';
      const timer = setTimeout(() => {
        navigate(from, { replace: true });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [user, loading, navigate, location]);

  // 如果未登录，重定向到登录页
  useEffect(() => {
    if (!loading && !user) {
      navigate('/login', { replace: true });
    }
  }, [user, loading, navigate]);

  useEffect(() => {
    // 恢复记住的用户名和密码
    const savedRememberMe = localStorage.getItem(STORAGE_KEYS.REMEMBER_ME) === 'true';
    if (savedRememberMe) {
      const savedUsername = localStorage.getItem(STORAGE_KEYS.SAVED_USERNAME);
      const savedPassword = localStorage.getItem(STORAGE_KEYS.SAVED_PASSWORD);
      if (savedUsername && savedPassword) {
        setRememberMe(true);
        form.setFieldsValue({
          username: savedUsername,
          password: savedPassword
        });
      }
    }
  }, [form]);

  const onFinish = async (values) => {
    // 参数验证
    if (!values.username || !values.password) {
      messageApi.error('用户名和密码不能为空');
      return;
    }

    setLoading(true);
    try {
      const result = await login(values.username, values.password);
      if (result.success) {
        // 处理记住密码
        if (rememberMe) {
          localStorage.setItem(STORAGE_KEYS.REMEMBER_ME, 'true');
          localStorage.setItem(STORAGE_KEYS.SAVED_USERNAME, values.username);
          localStorage.setItem(STORAGE_KEYS.SAVED_PASSWORD, values.password);
        } else {
          localStorage.removeItem(STORAGE_KEYS.REMEMBER_ME);
          localStorage.removeItem(STORAGE_KEYS.SAVED_USERNAME);
          localStorage.removeItem(STORAGE_KEYS.SAVED_PASSWORD);
        }

        messageApi.success('登录成功');
        const from = location.state?.from?.pathname || '/';
        navigate(from, { replace: true });
      } else {
        messageApi.error(result.message || '登录失败，请检查用户名和密码');
      }
    } catch (error) {
      console.error('Login error:', error);
      messageApi.error(error.message || '登录失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'url(' + require('@assets/images/login_bg.png') + ') no-repeat 100% 100% / cover'
    }}>
      <div
        style={{
          display: 'flex',
          width: 1100,
          height: 630,
        }}
      >
        <div style={{ width: '50%', height: '100%', background: 'url(' + require('@assets/images/dl_bg.png') + ') no-repeat 100% 100% / cover' }}>
          <h2 style={{ fontSize: 30, fontWeight: 600, color: '#fff', paddingLeft: 50, paddingTop: 70 }}>欢迎使用</h2>
          <h1 style={{ fontSize: 36, fontWeight: 800, color: '#fff', paddingLeft: 100 }}>名片管理系统</h1>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '50%', height: '100%', background: '#fff' }}>
          <h3 style={{ fontSize: 24, fontWeight: 600, color: '#008d6a' }}>欢迎登录</h3>
          <Form
            form={form}
            name="login"
            onFinish={onFinish}
            autoComplete="off"
            size="large"
            style={{ width: 400, height: 'auto' }}
          >
            <Form.Item
              name="username"
              rules={[
                { required: true, message: '请输入用户名' },
                { min: 3, message: '用户名至少3个字符' }
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="用户名"
                maxLength={20}
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { required: true, message: '请输入密码' },
                { min: 6, message: '密码至少6个字符' }
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="密码"
                maxLength={20}
              />
            </Form.Item>

            <Form.Item>
              <Checkbox
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                style={{ float: 'left' }}
              >
                记住密码
              </Checkbox>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                style={{
                  height: 40,
                  fontSize: 16
                }}
              >
                登录
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

// 主登录组件
const Login = () => {
  return (
    <App>
      <LoginForm />
    </App>
  );
};

export default Login; 